import Index from 'src/screens/index';
export default Index;
